export default __webpack_public_path__ + "a29236e0fc30e8482530aaf6986c7004.woff2";